export default {
  name: 'FPÖ',
  versions: ['fpoe/fpoe_1.jpg'],
  baseStyle: {
    fontFamily: '"Barlow",Helvetica,arial,"sans-serif"',
    color: '#FFFFFF',
    width: '80%',
    display: 'block',
    position: 'relative',
    marginTop: '2px',
    marginBottom: '8px',
    marginRight: '0px',
    paddingRight: '0px',
    lineHeight: '0.8'
  },
  containerStyle: {
    paddingBottom: '41%',
    paddingLeft: '15%'
  },
  customStyles: [
    {
      name: "dünn",
      style: {
      }
    },
    {
      name: "dick",
      style: {
        fontWeight: '700',
        textTransform: 'uppercase'
      }
    },
  ],
  linesDefault: [
    {
      text: 'Jö schau da:',
      style: 0,
      fontSize: 50
    },
    {
      text: 'Ein Vogerl!',
      style: 1,
      fontSize: 100
    },
  ],
}



// WEBPACK FOOTER //
// ./src/config/fpoe.js